import type { IAgentTool } from '../IAgentTool';
import { normalizeField } from '../../../assistant/utils/conditionEvaluation';

export const filterTool: IAgentTool = {
  name: 'filter',
  description: 'Filter nodes by a field and value. Dims or hides non-matching nodes.',
  parameters: {
    type: 'object',
    properties: {
      field: { type: 'string', description: 'Field to filter on (e.g., department, location)' },
      operator: { type: 'string', enum: ['equals', 'contains', 'greater_than', 'less_than'] },
      value: { type: 'string', description: 'Value to match' },
      effect: { type: 'string', enum: ['dim', 'hide'], default: 'dim' },
    },
    required: ['field', 'operator', 'value'],
  },
  supportedDiagramTypes: [],
  tier: 'visual',
  category: 'filter',

  async execute(params, context) {
    const field = normalizeField(String(params.field ?? '').trim());
    const operator = String(params.operator ?? 'equals') as 'equals' | 'contains' | 'greater_than' | 'less_than';
    const value = String(params.value ?? '').trim();
    const effect = (params.effect === 'hide' ? 'hide' : 'dim') as 'dim' | 'hide';

    if (!field || !value) {
      return { success: false, summary: 'Missing field or value for filter.' };
    }

    const before = context.stores.viewRules.getPrimaryFilter().conditions.map((c) => c.id);
    context.stores.viewRules.addCondition({ field, operator, value });
    context.stores.viewRules.setFilterEffect(effect);
    const after = context.stores.viewRules.getPrimaryFilter().conditions.map((c) => c.id);
    const createdIds = after.filter((id) => !before.includes(id));

    return {
      success: true,
      summary: `Filtered to nodes where ${field} ${operator} "${value}"`,
      createdResourceIds: createdIds,
    };
  },
};
